@if (courseData) {
  <div class="dialogContainer">
    <div class="dialogHeader">
      <img
        class="closeButton"
        src="/images/closeIconWithoutBox.png"
        (click)="closeDialog()"
        />
      </div>
      <div class="dialogContent">
        <div>
          <app-dialog-input-title
            title="Kursus kategori"
            [required]="true"
          ></app-dialog-input-title>
          <select
            [(ngModel)]="courseData.courseCategoryId"
            (change)="onCourseCategoryChange()"
            class="dropdown"
            >
            <option [ngValue]="0" class="hidden">Vælg kategori</option>
            @for (category of courseCategories; track category) {
              <option
                [ngValue]="category.id"
                >
                {{ category.name }}
              </option>
            }
          </select>
        </div>
        <div>
          <app-dialog-input-title
            title="Kursus navn"
            [required]="true"
          ></app-dialog-input-title>
          <input type="text" class="Textbox" [(ngModel)]="courseData.name" />
        </div>
        <div>
          <app-dialog-input-title
            title="Kursus beskrivelse"
            [required]="true"
          ></app-dialog-input-title>
          <div class="subTitleText">Fyldig beskrivelse, mindst 25 tegn</div>
          <textarea
            type="text"
            class="descriptionTextarea"
            [(ngModel)]="courseData.description"
            >
          </textarea>
        </div>
        <div>
          <app-dialog-input-title title="Kursus link"></app-dialog-input-title>
          <input type="text" class="Textbox" [(ngModel)]="courseData.courseLink" />
        </div>
        <div>
          <app-dialog-input-title
            title="Gyldighed (år)"
            [required]="true"
          ></app-dialog-input-title>
          <input type="text" class="Textbox" [(ngModel)]="courseData.yearsValid" />
        </div>
      </div>
      @if (!checkUrl()) {
        <div class="dialogFooter">
          <app-save-button
      [disabled]="
        courseData.courseCategoryId == 0 ||
        !courseData.name.trim() ||
        courseData.description.length < 25 ||
        !courseData.yearsValid
      "
            [clickEvent]="saveChanges.bind(this)"
            >
          </app-save-button>
          <app-delete-button [clickEvent]="deleteCourse.bind(this)">
          </app-delete-button>
        </div>
      }
    </div>
  }
